import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMotorcycle,
  faShippingFast,
  faCar,
  faTruck,
  faTruckMoving,
  faBus,
  faPlane,
} from "@fortawesome/free-solid-svg-icons";
function Fleet() {
  

const fleetItems = [
  {
    vehicle: "Motorbike",
    description:
      "For an efficient and speedy delivery, our motorbikes can carry anything from forgotten passports and lost keys to an A4-sized box up to 10kg in weight.",
    icon: <FontAwesomeIcon icon={faMotorcycle} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "Small Van",
    description:
      "Our small vans are suited to a wide range of individual jobs. They can carry the equivalent of 50 A4-sized boxes or a standard pallet up to 450kg in weight.",
    icon: <FontAwesomeIcon icon={faShippingFast} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "ULEV",
    description:
      "Concerned about the environment? We have access to a fleet of Ultra Low Emission Vehicles (ULEV) that are dedicated to reducing environmental impact.",
    icon: <FontAwesomeIcon icon={faCar} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "SWB Van",
    description:
      "For jobs that are too big for our smaller vans, our SWB Transit Vans are the perfect option. They can carry 2 standard pallets and up to 700kg in weight.",
    icon: <FontAwesomeIcon icon={faTruck} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "MWB Van",
    description:
      "Our medium vans are suited to a wide range of individual jobs. They can carry 2-3 standard pallets and up to 800kg in weight.",
    icon: <FontAwesomeIcon icon={faTruck} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "LWB Van",
    description:
      "LWB Transit Vans are a further step up from an MWB Van. They’re flexible to carry out an array of jobs and can transport 3 standard pallets up to 1000kg in weight.",
    icon: <FontAwesomeIcon icon={faTruckMoving} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "XLWB Van",
    description:
      "XLWB Transit Vans are built for purpose and can be relied upon to get the job done. Ideal for moving large loads up to 4 standard pallets and weighing up to 1000kg.",
    icon: <FontAwesomeIcon icon={faTruckMoving} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "Luton Van",
    description:
      "Luton Vans (curtain or box side) are renowned for their versatility. They’re ideal for unusually-sized loads up to 6 standard pallets or 1000kg.",
    icon: <FontAwesomeIcon icon={faTruckMoving} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "7.5 Tonne Van",
    description:
      "For extra space and heavy loads, choose our 7.5 Tonne Vans (curtain or box side). With a maximum load of 10 standard pallets or 2500kg, there’s not a lot that can’t be moved with this option.",
    icon: <FontAwesomeIcon icon={faTruck} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "18 Tonne Lorry",
    description:
      "Carrying up to 14 standard pallets or 9000kg, this is one of our largest road haulage options. For an extra-large delivery that you need transporting all at once.",
    icon: <FontAwesomeIcon icon={faTruck} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "Artic Lorry",
    description:
      "The largest option in our fleet. Able to transport up to 26 standard pallets and a total weight of 27,000kg. They’re available on request and are an efficient way of moving cross-country loads all in one journey.",
    icon: <FontAwesomeIcon icon={faBus} className="w-24 h-24 text-gray-600" />,
  },
  {
    vehicle: "Aircraft",
    description:
      "Our fleet includes a wide range of… not really. However, at 1UKLogistics we’re determined to go to great lengths to provide you with the top-quality service that you deserve.",
    icon: <FontAwesomeIcon icon={faPlane} className="w-24 h-24 text-gray-600" />,
  },
];

  return (
    <div>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[580px]"
        style={{ backgroundImage: "url('images/fleetbg.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-7xl xl:text-8xl font-semibold">The Fleet</h1>
          <p className='text-xl md:text-2xl'>Optimized fleet, seamless deliveries—driving logistics forward</p>
        </div>
      </div>

      <div className="bg-white text-black md:px-12 font-thin justify-center items-center flex flex-col text-center   py-10 space-y-6  ">
  <p className="md:text-2xl md:leading-10  text-justify p-3 max-w-5xl">
  At 1UKLogistics, our fleet is the backbone of our reliable and efficient transportation services. We operate a diverse range of well-maintained vehicles, including light-duty vans, heavy-duty trucks, and specialized trailers, ensuring that every shipment—big or small—is delivered with precision and care. Our fleet is equipped with advanced GPS tracking, real-time monitoring, and safety-enhancing features to provide secure and timely deliveries across Service Areas.

  </p>

  <p className="md:text-2xl   text-justify p-3 max-w-5xl md:leading-10">
  We take pride in maintaining our vehicles to the highest industry standards, conducting regular inspections and servicing to guarantee peak performance. Whether it's local distribution or long-haul freight, our fleet is optimized to handle a variety of logistics needs with flexibility and efficiency. With experienced drivers and a commitment to sustainability, we continuously invest in fuel-efficient and eco-friendly transportation solutions to reduce our carbon footprint while delivering excellence on the road.
  </p>
</div>

<h1 className='text-center text-4xl md:text-5xl font-thin p-3'>Fleet Solutions for Every Need</h1>
      {/* Fleet Section */}
      <section id="fleet" className="py-16 bg-white-800 text-black md:px-12 xl:px-60">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
          {fleetItems.map((item, index) => (
            <div key={index} className="flex flex-col gap-6 items-center text-center mt-6">
              <h3 className="text-xl  font-thin mb-1  ">{item.vehicle}</h3>
              <div className="mb-2   ">{item.icon}</div>
              <p className="text-zinc-500  font-thin max-w-sm">{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="relative  bg-cover bg-center  bg-no-repeat w-full  py-36 mt-20" style={{ backgroundImage: "url('images/fleetfooter.jpeg') " }}>
          <div className="absolute inset-0 bg-black bg-opacity-60"></div>
          <div className="relative z-10 container mx-auto text-center text-white px-6">
          <h2 className="text-3xl md:text-[45px] mb-6">For more information about our Fleet Solutions, please contact us.</h2>
            <div className=" flex justify-center">
            </div>
          
            <a
              href="/contactus"
              className="inline-block bg-gray-200 text-black  px-8 py-2 md:py-3 uppercase shadow-lg hover:bg-slate-800 hover:text-white transition duration-300"
            >
              Contact Us
            </a>
          </div>
        </section>
    </div>
  );
}

export default Fleet;
